/**
 * @fileoverview カードコンポーネント
 *
 * このファイルでは、コンテンツをグループ化してカード形式で表示するための
 * コンポーネントを定義しています。一貫した枠組みとスタイルを提供し、
 * さまざまなコンテンツタイプに対応します。
 */

/**
 * カードコンポーネント
 *
 * コンテンツを視覚的にグループ化し、境界線とスタイルを適用して
 * カード形式で表示します。タイトル、説明、メインコンテンツを
 * 構造化して配置するためのレイアウトを提供します。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} [props.title] - カードのタイトル
 * @param {string} [props.description] - カードの簡単な説明
 * @param {React.ReactNode} props.children - カード内に表示するメインコンテンツ
 * @param {string} [props.className] - 追加のCSSクラス名
 * @returns {JSX.Element} カードコンポーネント
 */
import { FC, ReactNode } from "react";
import { Card as MantineCard, Title, Text } from "@mantine/core";

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
};

export const Card: FC<Props> = ({ title, description, children }) => {
  return (
    <MantineCard className="w-[30rem]" padding={0} radius="lg">
      <MantineCard.Section className="p-8 bg-blue-600 text-white flex flex-col gap-5">
        <Title>{title}</Title>
        {description !== undefined ? <Text>{description}</Text> : null}
      </MantineCard.Section>
      <div className="w-full p-8">{children}</div>
    </MantineCard>
  );
};
